"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _RequestPaymentConfiguration_1 = require("./_RequestPaymentConfiguration");
exports.PutBucketRequestPaymentInput = {
    type: "structure",
    required: ["Bucket", "RequestPaymentConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        RequestPaymentConfiguration: {
            shape: _RequestPaymentConfiguration_1._RequestPaymentConfiguration,
            locationName: "RequestPaymentConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "RequestPaymentConfiguration"
};
//# sourceMappingURL=PutBucketRequestPaymentInput.js.map